module.exports = __webpack_public_path__ + "img/b.fbd4325e.jpg";